import { Component, Input, OnChanges, OnInit } from "@angular/core";
import "./ahead-behind.component.scss";

@Component({
    selector: "ahead-behind",
    template: require("./ahead-behind.component.html")
})
export class AheadBehindComponent implements OnInit, OnChanges {

    @Input() left: number;
    @Input() right: number;
    @Input() max: number;

    // ---

    leftPercentage: number;
    rightPercentage: number;

    constructor() {
    }

    ngOnInit() {
        this.calculateBarWidths();
    }

    ngOnChanges() {
        this.calculateBarWidths();
    }

    // ---

    private calculateBarWidths() {
        this.leftPercentage = this.left * 100 / this.max;
        this.rightPercentage = this.right * 100 / this.max;
    }
}
